import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

// Calculate total sum

const DonutChart = ({ data, title, valuemapKey }) => {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div
          className="back-white flex-col align-center justify-center g-05 p-1 radius-6"
          style={{ border: "2px solid var(--greenColor)" }}
        >
          <p className="text-sm text-gray-600">
            Value: {payload[0].payload[valuemapKey]}
          </p>
        </div>
      );
    }
    return null;
  };
  return (
    <div className="flex justify-center items-center h-screen relative">
      <PieChart width={240} height={246}>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={80} // Creates the donut hole
          outerRadius={120}
          fill="#8884d8"
          paddingAngle={5}
          dataKey={valuemapKey}
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={entry.positionColor || COLORS[index % COLORS.length]}
            />
          ))}
        </Pie>
        <Tooltip content={<CustomTooltip />} />
      </PieChart>

      {/* Total Count in Center */}
      <div
        className="flex-col align-center g-05 absolute text-xl font-bold"
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <span style={{textAlign:"center"}} className="t-14 poppins color-grayBorder">{title}</span>
        <span className="t-29 poppins weight-bold color-grayBorder">
          {data && data.length}
        </span>
      </div>
    </div>
  );
};

export default DonutChart;
